export default __webpack_public_path__ + "static/media/Infographics.d1244a3b.svg";